const TMenuEditorScreen = {
    // English
    "enUS": {
        'EDITOR': 'Menu Editor',
        'MENU_TYPE': 'Menu Type',
        'MENU_TYPE_DESC': 'Select the type of menu you want to display',
        'UPLOAD_FILE': 'PDF File',
        'MESSAGE_ONLY_PDF_FILES': 'Only PDF files are allowed',
        'MESSAGE_MAX_SIZE': 'File size should not exceed 20 MB',
        'DIGITAL_TYPE': 'Digital',
        'DIGITAL_TYPE_DESC': 'Create it from scratch using our editor and customize it as you wish',
        'FILE_UPLOADED': '1 File Uploaded',
        'PDF_TYPE': 'PDF',
        'PDF_TYPE_DESC': 'If you already have a PDF you could simply upload it',
        'HEADER': 'Header',
        'HEADER_DESC': "Logo and restaurant name",
        'CUSTOMIZE': 'Customize',
        'CARD_STYLES': 'Food Styles',
        'MENU_NAME': 'Menu Name',
        'PRIMARY_COLOR': 'Main Color',
        'BACKGROUND_COLOR': 'Background Color',
        'FONT_FAMILY': 'Font Family',
        'SAVE': 'Save',
        'PROMOS': 'Promos',
        'SECTIONS': 'Categories',
        'SECTIONS_DESC': 'Manage your food',
        'CHANGE_PROMOS': 'Change Promos',
        'ADD_FOOD': 'Search',
        'NEW_FOOD': 'New Food',
        'ADD_SECTION': 'Add Category',
        'NEW_SECTION': 'New Category',
        'SECTION_NAME': 'Name (Ex. Burgers, Drinks)',
        'SECTION_DESC': 'Description (Optional)',
        'EDIT': 'Edit',
        'DELETE_SECTION': 'Delete',
        'DELETE': 'Delete',
        'CANCEL': 'Cancel',
        'REMOVE': 'Remove',
        'DELETE_FOOD': 'Remove Food',
        'DELETE_FOOD_TEXT': 'Do you wish to remove this food from your menu?',
        'DELETE_SECTION_TITLE': 'Delete category',
        'DELETE_SECTION_TEXT': 'Do you wish to delete this category for your menu?',
        'CONFIRM_DELETE_SECTION_TEXT': 'Delete',
        'THEME': 'Theme',
        'CARDS': 'Cards',
        'MINIMALISTIC': 'Minimalistic',
        'OPACITY': 'Opacity',
        'BORDER_RADIUS': 'Corner Softness',
        'BORDER_WIDTH': 'Border Width',
        'BORDER_COLOR': 'Border Color',
        'SHADOW_INTENSITY': 'Shadow Intensity',
        'PREVIEW': 'Preview',
        'AVAILABLE_BASIC': 'Available with the Basic Plan',
        'TEXT_ALIGN': 'Text Alignment',
        'LEFT': 'Left',
        'CENTER': 'Center',
        'RIGHT': 'Right',

        'TO_MENU': 'Go To Menu',
        'QR_CODE': 'QR Code',

        'NO_CATEGORIES_ADDED': 'No categories have been added, try creating one',

        //FOR PREVIEW
        'PREVIEW_DESC': 'See how your menu will look and save your changes',
        'PREVIEW_SECTION': 'Category',
        'PREVIEW_FOOD': 'Food',
        'PREVIEW_DESCRIPTION': 'Velit necessitatibus et voluptatem culpa. Eos sit voluptas laudantium qui odio blanditiis accusantium. Quia culpa quos soluta cupiditate. Similique recusandae vel est repudiandae expedita. In quas iusto dolor. Molestiae dolor exercitationem et.',
    },
    // Spanish
    "esMX": {
        'EDITOR': 'Editor de Menú',
        'MENU_TYPE': 'Tipo de Menú',
        'MENU_TYPE_DESC': 'Tipo de Menú que mostrarás',
        'UPLOAD_FILE': 'Archivo PDF',
        'MESSAGE_ONLY_PDF_FILES': 'Debe ser un PDF',
        'MESSAGE_MAX_SIZE': 'El tamaño no puede ser superior a 20 MB',
        'DIGITAL_TYPE': 'Digital',
        'DIGITAL_TYPE_DESC': 'Crea tu menú desde zero con nuestro editor y cambia su apariencia a tu gusto',
        'FILE_UPLOADED': '1 Archivo Subido',
        'PDF_TYPE': 'PDF',
        'PDF_TYPE_DESC': 'Si ya cuentas con un archivo PDF puedes simplemente subirlo',
        'HEADER': 'Cabecera',
        'HEADER_DESC': "Logo y nombre del restaurante",
        'CUSTOMIZE': 'Apariencia',
        'CARD_STYLES': 'Estilos del Alimento',
        'MENU_NAME': 'Nombre del Menú',
        'PRIMARY_COLOR': 'Color Principal',
        'BACKGROUND_COLOR': 'Color de Fondo',
        'FONT_FAMILY': 'Fuente de Letra',
        'SAVE': 'Guardar',
        'SECTIONS': 'Categorías',
        'SECTIONS_DESC': 'Administra tus alimentos',
        'PROMOS': 'Promociones',
        'ADD_FOOD': 'Buscar',
        'NEW_FOOD': 'Crear Alimento',
        'ADD_SECTION': 'Agregar Categoría',
        'CHANGE_PROMOS': 'Cambiar Promociones',
        'NEW_SECTION': 'Nueva Categoría',
        'SECTION_NAME': 'Nombre (Ej. Pizzas, Bebidas)',
        'SECTION_DESC': 'Descripción (Opcional)',
        'EDIT': 'Editar',
        'DELETE_SECTION': 'Borrar',
        'DELETE': 'Borrar',
        'CANCEL': 'Cancelar',
        'REMOVE': 'Remover',
        'DELETE_FOOD': 'Remover Alimento',
        'DELETE_FOOD_TEXT': '¿Desea remover este alimento de su menú?',
        'DELETE_SECTION_TITLE': 'Borrar Categoría',
        'DELETE_SECTION_TEXT': '¿Desea borrar esta categoría de su menú?',
        'CONFIRM_DELETE_SECTION_TEXT': 'Borrar',
        'THEME': 'Tema',
        'CARDS': 'Tarjetas',
        'MINIMALISTIC': 'Minimalista',
        'OPACITY': 'Opacidad',
        'BORDER_RADIUS': 'Suavizado de Esquinas',
        'BORDER_WIDTH': 'Ancho de Bordes',
        'BORDER_COLOR': 'Color de Bordes',
        'SHADOW_INTENSITY': 'Intensidad de Sombras',
        'PREVIEW': 'Ver y Guardar',
        'AVAILABLE_BASIC': 'Disponible con el Plan Básico',
        'TEXT_ALIGN': 'Alineamiento del Texto',
        'LEFT': 'Izquierda',
        'CENTER': 'Centrar',
        'RIGHT': 'Derecha',

        'TO_MENU': 'Ver Menú',
        'QR_CODE': 'Código QR',

        'NO_CATEGORIES_ADDED': 'No se han agregado Categorías, intenta crear una',

        //FOR PREVIEW
        'PREVIEW_DESC': 'Vee como se verá tu menú y guarda tus cambios',
        'PREVIEW_SECTION': 'Categoría',
        'PREVIEW_FOOD': 'Alimento',
        'PREVIEW_DESCRIPTION': 'Velit necessitatibus et voluptatem culpa. Eos sit voluptas laudantium qui odio blanditiis accusantium. Quia culpa quos soluta cupiditate. Similique recusandae vel est repudiandae expedita. In quas iusto dolor. Molestiae dolor exercitationem et.',
    }
}
export default TMenuEditorScreen;